module.exports = __webpack_public_path__ + "static/media/arrow-right--white.108688c6.svg";